<template>
    <div class="logo-watermark" :style="`background-image: url(${bg}),url(${bg});`"></div>
</template>
<script>
export default {
    data() {
        return {
            bg: 'https://res.peki.vip/20230106/6cbeff6754c647e7842ac6e8c702cd01.png',
        }
    },
}
</script>
<style lang="scss" scoped>
.logo-watermark {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
    z-index: 999;
    opacity: 0.1;
    background-repeat: repeat;
    background-position: 0 0, 150px 150px;
    background-size: 300px;
}
@media screen and (max-width: 640px) {
    .logo-watermark {
        background-position: 0 0, 100px 100px;
        background-size: 200px;
    }
}
</style>
